const projects = 
    [
        { // Github set up properly
            date: "Nov 2023 - Feb 2024", 
            title: "Video Intelligence for Healthcare",
            content: "*- Developed a user-friendly web app interface for elderly and caregivers to interact with the real-time pill detection feature.\
            *- Trained object detection models for pill detection using Ultralytics' pre-trained models.\
            *- Created a drag-and-drop memory game within the web app for evaluating the cognitive ability of a patient.",
            github: "https://github.com/exfang/Video-Intelligence",
            category: "Data Science with Machine Learning",
        },

        { // Github set up properly
            date: "Jun 2023 - Aug 2023", 
            title: "Big Data Management Project",
            content: "*- Sourced and cleaned data for Machine Learning.\
            *- Trained classification models such as Decision Tree, Logistic Regression, and Gradient Boosting Classifier.\
            *- Automated the prediction of Heart Disease on streaming batch data with Databricks.",
            github: "https://github.com/exfang/Big-Data-Management",
            category: "Data Science with Machine Learning",
        },

        { // Github set up properly
            date: "Jun 2023 - Aug 2023", 
            title: "Applied Deep Learning",
            content: "*- Trained Tensorflow deep learning models, pre-trained and from scratch, for image and text sentiment classification.",
            github: "https://github.com/exfang/Applied-Deep-Learning",
            category: "Data Science with Machine Learning",
        },
        
        { // Github set up properly
            date: "Apr 2023 - Jun 2023", 
            title: "HDB Resale Price Analysis with D3", 
            content: "*- Developed a dashboard with D3.\
            *- Plotted visualizations with D3 for conveying insights and recommendations.",
            github: "https://github.com/exfang/Data-Visualization-with-D3",
            category: "Data Analytics",
        },

        { // Github set up properly
            date: "Dec 2022 - Feb 2023", 
            title: "Sentiment Analysis & Topic Modelling",
            content: "*- Cleaned review texts from eCommerce shopping platforms.\
            *- Trained Machine Learning models for Sentiment Analysis and Topic Modelling with the cleaned review texts.",
            github: "https://github.com/exfang/Sentiment-Analysis-and-Topic-Modelling",
            category: "Data Science with Machine Learning",
        },
  
        { // Github set up properly
            date: "Dec 2022 - Feb 2023", 
            title: "Text & Social Analytic Project",
            content: "*- Scraped Disneyland Park Reviews using Selenium and BeautifulSoup. \
            *- Cleaned and analyzed reviews on Jupyter Notebook.\
            *- Trained classification models such as Random Forest and Logistic Regression for sentiment classification.\
            *- Performed Topic Modelling on texts using the gensim library's latent dirichlet allocation model.",
            github: "https://github.com/exfang/Text-and-Social-Analytics-Project",
            category: "Data Science with Machine Learning",
        },
  
        { // Github set up properly
            date: "Jun 2022 - Aug 2022", 
            title: "Data Analytics with Tableau",
            content: "*- Analyzed the data of a ficticious bicycle company, Adventure Works Cycle, on Tableau.\
            *- Derive insights and provide recommendations for improving sales performance.",
            github: "https://github.com/exfang/Data-Analysis-on-Tableau",
            category: "Data Analytics",
        },
  
        { // Github set up properly
            date: "Jun 2022 - Aug 2022", 
            title: "Web Application Development with Flask and Python",
            content: "*- Focused on customer accounts and page navigations.\
            *- Utilized Flask, Jinja, and HTML for developing the web app.\
            *- Allowed users to create, retrieve, update, and delete their accounts.\
            *- Set rules to prevent unauthorized access to customer accounts.",
            github: "https://github.com/exfang/Webapp-Development",
            category: "Web Development",
        },

        { // Github set up properly
            date: "Dec 2021 - Feb 2022", 
            title: "Visual Analytics with Power BI",    
            content: "*- Focused on Transport and Security within Singapore.\
            *- Sourced and cleaned data for analysis.\
            *- Plotted visualizations on Power BI for analysis.\
            *- Provided insights and recommendations for making Singapore a better place to live in.",
            github: "https://github.com/exfang/Visual-Analytics-with-Power-BI",
            category: "Data Analytics",
        },
        
  ];
  
  export default projects;